import { checkIsSmallScreen } from 'utils/screen'
import { useEffect, useState } from 'react'
import Desktop from './Desktop'
import Mobile from './Mobile'

const View = () => {
  const [isSmallScreen, setSmallScreen] = useState(checkIsSmallScreen())
  useEffect(() => {
    const onResize = () => {
      if (checkIsSmallScreen() !== isSmallScreen) setSmallScreen(s => !s)
    }
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [isSmallScreen])

  return isSmallScreen ? <Mobile /> : <Desktop />
}

export default View
